import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const MentorNav = ({ authUser, signOut }) => {
  const location = useLocation();

  return (
    <div className='dropdown'>
      <a
        href='#/'
        className='d-inline-flex align-items-center link-dark text-decoration-none dropdown-toggle px-3 py-2 rounded-pill bg-white border shadow-xs transition-all hover-scale'
        data-bs-toggle='dropdown'
        aria-expanded='false'
        style={{ border: '1px solid #e2e8f0' }}
      >
        <div
          className='p-1 bg-success bg-opacity-10 text-success rounded-circle me-2 d-flex align-items-center justify-content-center'
          style={{ width: '32px', height: '32px' }}
        >
          <i className='bi bi-person-badge-fill small'></i>
        </div>
        <div className='text-start me-2'>
          <div
            className='fw-bold text-dark mb-0 leading-tight'
            style={{ fontSize: '0.875rem' }}
          >
            {authUser?.fullName}
          </div>
          <div
            className='text-muted small'
            style={{ fontSize: '0.75rem' }}
          >
            Mentor
          </div>
        </div>
      </a>

      <ul
        className='dropdown-menu dropdown-menu-lg-end shadow-lg border-0 rounded-4 p-2 mt-2 mt-lg-3'
        style={{
          minWidth: '260px',
          border: '1px solid rgba(0,0,0,0.05)',
        }}
      >
        <li className='px-3 py-2 mb-2'>
          <h6 className='fw-bold text-dark mb-0'>
            {authUser?.fullName}
          </h6>
          <small className='text-muted'>{authUser?.email}</small>
          <div className='mt-2'>
            <span className='badge bg-success bg-opacity-10 text-success rounded-pill x-small'>
              Mentor
            </span>
          </div>
        </li>

        <li>
          <hr className='dropdown-divider opacity-50' />
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${location.pathname === '/mentor' ? 'active' : ''}`}
            to='/mentor'
          >
            <i
              className={`bi bi-house-fill ${location.pathname === '/mentor' ? 'text-white' : 'text-success opacity-75'}`}
            ></i>
            <span>Dashboard</span>
          </Link>
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${location.pathname === '/mentor/registrations' ? 'active' : ''}`}
            to='/mentor/registrations'
          >
            <i
              className={`bi bi-box-arrow-in-right ${location.pathname === '/mentor/registrations' ? 'text-white' : 'text-success opacity-75'}`}
            ></i>
            <span>Pendaftaran</span>
          </Link>
        </li>

        <li className='dropdown-header small text-uppercase text-muted fw-bold pt-2 pb-1'>
          Penilaian
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ps-4 ${location.pathname.startsWith('/mentor/mentees/evaluations') ? 'active' : ''}`}
            to='/mentor/mentees/evaluations'
          >
            <i
              className={`bi bi-people-fill ${location.pathname.startsWith('/mentor/mentees/evaluations') ? 'text-white' : 'text-success opacity-75'}`}
            ></i>
            <span>Mahasiswa</span>
          </Link>
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ps-4 ${location.pathname === '/mentor/classifications' ? 'active' : ''}`}
            to='/mentor/classifications'
          >
            <i
              className={`bi bi-hand-thumbs-up-fill ${location.pathname === '/mentor/classifications' ? 'text-white' : 'text-success opacity-75'}`}
            ></i>
            <span>KPI</span>
          </Link>
        </li>

        <li>
          <Link
            className={`dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 ${location.pathname.startsWith('/mentor/attendances') ? 'active' : ''}`}
            to='/mentor/attendances'
          >
            <i
              className={`bi bi-list-check ${location.pathname.startsWith('/mentor/attendances') ? 'text-white' : 'text-success opacity-75'}`}
            ></i>
            <span>Kehadiran</span>
          </Link>
        </li>

        <li>
          <hr className='dropdown-divider opacity-50' />
        </li>

        <li>
          <a
            onClick={(e) => {
              e.preventDefault();
              signOut();
            }}
            className='dropdown-item d-flex align-items-center gap-2 py-2 rounded-3 text-danger'
            href='#/'
          >
            <i className='bi bi-box-arrow-right'></i>
            <span className='fw-bold'>Sign out</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default MentorNav;
